import React, {Fragment} from 'react';
import StarRating from '@homeaway/react-star-rating';
import './Rating.less';
import {FormattedMessage} from 'react-intl';

const Rating = ({listing: {averageRating, reviewCount, starSize}}) => {
    if (!reviewCount) {
        return (
            <span className="sr-only">
                <FormattedMessage id="noReviews" defaultMessage="no reviews" />
            </span>
        );
    }

    return (
        <Fragment>
            <div className={'Rating__starRating'} aria-hidden="true">
                <StarRating rating={averageRating} size={starSize} />
            </div>
            <span className="Rating__ratingcount" aria-hidden="true">
                {`(${reviewCount})`}
            </span>
            <span className="sr-only">
                <FormattedMessage
                    id="ratingScreenReaderLabel"
                    defaultMessage="Guest Rating: {rating} out of possible 5 stars. Number of Reviews: {reviewCount}"
                    values={{
                        rating: averageRating.toFixed(2),
                        reviewCount
                    }}
                >
                    {(txt) => txt}
                </FormattedMessage>
            </span>
        </Fragment>
    );
};

export default Rating;
